module.exports = __webpack_public_path__ + "img/uotz-white-logo.a765a684.png";